// extracted by mini-css-extract-plugin
export default {"modal":"EditMyCollectionModal-module__modal","container":"EditMyCollectionModal-module__container"};